import { createSlice } from "@reduxjs/toolkit";
import {
  getFrasesRespuestaThunk,
  getFraseRespuestaByIdThunk,
  updateFraseRespuestaThunk,
} from "./frasesRespuesta.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  count: 0,
  next: null,
  previous: null,
  search: "",

  selectedFraseRespuesta: null,
  selectedFraseRespuestaLoading: false,
  selectedFraseRespuestaError: null,
  viewModalOpen: false,

  editModalOpen: false,
  editLoading: false,
  editError: null,
};

const frasesRespuestaSlice = createSlice({
  name: "frasesRespuesta",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedFraseRespuesta = null;
    },
    openEditModal: (state, action) => {
      state.editModalOpen = true;
      if (action.payload?.fraseRespuesta) {
        state.selectedFraseRespuesta = action.payload.fraseRespuesta;
      }
      state.editError = null;
    },
    closeEditModal: (state) => {
      state.editModalOpen = false;
      state.selectedFraseRespuesta = null;
      state.editError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getFrasesRespuestaThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrasesRespuestaThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results || [];
        state.count = action.payload.count || 0;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
      })
      .addCase(getFrasesRespuestaThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getFraseRespuestaByIdThunk.pending, (state) => {
        state.selectedFraseRespuestaLoading = true;
        state.selectedFraseRespuestaError = null;
      })
      .addCase(getFraseRespuestaByIdThunk.fulfilled, (state, action) => {
        state.selectedFraseRespuestaLoading = false;
        state.selectedFraseRespuesta = action.payload;
      })
      .addCase(getFraseRespuestaByIdThunk.rejected, (state, action) => {
        state.selectedFraseRespuestaLoading = false;
        state.selectedFraseRespuestaError = action.payload;
      })

      // UPDATE
      .addCase(updateFraseRespuestaThunk.pending, (state) => {
        state.editLoading = true;
        state.editError = null;
      })
      .addCase(updateFraseRespuestaThunk.fulfilled, (state) => {
        state.editLoading = false;
        state.editModalOpen = false;
        state.selectedFraseRespuesta = null;
      })
      .addCase(updateFraseRespuestaThunk.rejected, (state, action) => {
        state.editLoading = false;
        state.editError = action.payload;
      });
  },
});

export const {
  clearError,
  setPage,
  setSearch,
  openViewModal,
  closeViewModal,
  openEditModal,
  closeEditModal,
} = frasesRespuestaSlice.actions;

export default frasesRespuestaSlice.reducer;
